import React, { useState, useEffect, useRef } from 'react'
import { Button, Spinner, Table } from 'react-bootstrap';
import { DatatableWrapper, Pagination, TableBody, TableHeader } from 'react-bs-datatable';
import fuziElevatorsApi from '../../api/fuziElevatorsApi';
import { ROUTES } from '../../constants/webRouting';
import { Link } from 'react-router-dom';
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import OfferPdf from "./OfferPdf";
import ReactDOMServer from "react-dom/server";
import { formatDate,formatDateForView } from '../../utils/helper';
const RelatedListOffer = (props) => {
    const pdfContent = useRef(null);
    const [body, setBody] = useState([]);
    const [offer, setOffer] = useState({});
    const [logo, setLogoUrl] = useState("");
    // modal state
    // const [modalShowSiteVisit, setModalShowSiteVisit] = useState(false);
    // visit data 
    // const [offerData, setOfferData] = useState(null);
    // useEffect(()=>{console.log('offerData',offerData)},[offerData]);
    const urlContentToDataUri = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to load image");
            const blob = await response.blob();
            return new Promise((resolve) => {
                let reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error loading image:", error);
            return ""; // Fallback if fetch fails
        }
    };
    async function init() {
        let userTrackings = await fuziElevatorsApi.fetchOffersByLeadId(props.lead.id);
        //console.log('userTrackings', userTrackings);
        if (userTrackings && userTrackings?.length > 0) {
            setBody(userTrackings);
        } else {
            setBody([]);
        }
        let logo1 = await urlContentToDataUri('/fuzi_classic_elevators_pvt_ltd_cover.jpg');
        console.log("logo1,", logo1);
        setLogoUrl(logo1);
        // urlContentToDataUri("/fuziElevatorsLogo.jpg").then((logo1) => {
        //     console.log("Logo1:", logo1);

        // });
    }
    useEffect(() => {
        init();
    }, [props?.refreshSiteVisitList]);



    // const editUser = (offerData) => {
    //     setOfferData(offerData);
    //     setModalShowSiteVisit(true);
    // }
    // const submitSiteVisit = () => {
    //     setModalShowSiteVisit(false);
    //     init();
    // };

    // const labels = {
    //     beforeSelect: " "
    // }

    //formatDateForView added by shahir hussain 28-08-2025
    const header = [
        { title: 'Offer Reference no', prop: 'offer_ref_no', cell : (row) => (`R-${row?.offer_ref_no}`) },
        { title: 'Offer Name', prop: 'offer_name', cell: (row) => <Link to={`${ROUTES.OFFER.LIST}/${row.id}`} state={row}> {row.offer_name} </Link> },
        { title: 'Offer Status', prop: 'offer_status' },
        { title: 'Assign User', prop: 'owner_id', cell: (row) => <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`} state={row}> {row.owner_name} </Link> },
        { title: 'Remarks', prop: 'remarks' },
        { title: 'Offer Date', prop: 'offer_date', cell: (row)=>row?.offer_date ? formatDateForView(row.offer_date) : ''},
        { title: 'Created Date', prop: 'createddate', cell: (row)=>row?.createddate ? formatDateForView(row.createddate) : '' },
        {
            title: "Actions",
            prop: "id",
            cell: (row) => (
                <Button
                    size="sm"
                    className="btn-custom"
                    onClick={() => CreatePdf(row)}
                >
                    <i className="fa-solid fa-download"></i>
                </Button>
            ),
        },
    ];




    const CreatePdf = (offer) => {
        setOffer(offer);
        setTimeout(() => {
            pdfContent.current && (()=>{
                
                // we can also use this 
                // const pdf = ReactDOMServer.renderToStaticMarkup(React.createElement(OfferPdf));
                // var html = htmlToPdfmake(pdfContent.current?.innerHTML, {
                //     tableAutoSize: true,
                //     defaultStyles:{ 
                //     }
                // });
                const pdf = document.getElementById("pdfContent");
                var html = htmlToPdfmake(pdf.innerHTML, {
                        tableAutoSize: true,
                        defaultStyles:{ 
                            font: 'arialunicodems1'
                        }
                    });
                const documentDefinition = {
                    // pageOrientation: 'landscape',
                    content: [html],
                    pageBreakBefore: function (currentNode) {
                        return currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1;
                    }
                };
                pdfMake.fonts = {
                    arialunicodems1: {
                        // normal: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
                        // bold: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
                    },
                    Roboto: {
                        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
                    }
                }
                pdfMake.vfs = pdfFonts.pdfMake.vfs;
                pdfMake.createPdf(documentDefinition).open();
            })();


        }, 500)

        // const pdfTable = document.getElementById("divToPrint");
        // var html = htmlToPdfmake(pdfTable.innerHTML, {
        //     tableAutoSize: true,
        // });
        // const documentDefinition = {
        //     content: [html],
        //     pageBreakBefore: function (currentNode) {
        //         return currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1;
        //     }
        // };
        // pdfMake.vfs = pdfFonts.pdfMake.vfs;
        // pdfMake.createPdf(documentDefinition).download("Offer PDF");
    };

    return (
        <>
            <DatatableWrapper
                body={body}
                headers={header}
                paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 5
                    }
                }}
            >
                <Table striped className="related-list-table shadow rounded sm" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {(body && Array.isArray(body)) ?
                        <TableBody />
                        :
                        <tbody className="">
                            <tr>
                                <td colSpan={100} align="center">
                                    <div>
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    }
                </Table>
                <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
            </DatatableWrapper>
            <div className="App container mt-5" style={{ display: 'none' }}>
                <div ref={pdfContent} id='pdfContent'>
                    <OfferPdf offer={offer} lead={props.lead} logo={logo} />
                </div>
            </div>
        </>

    )
};

export default RelatedListOffer
